import React from "react";
import { Profile } from "../../components/profile/profile";

export const ProfilePage = () => {
  return <div><Profile/></div>;
};
